var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 34.7487C10 30.3361 10 28.1298 10.3468 26.2919C11.8732 18.2015 18.2015 11.8732 26.2919 10.3468C28.1298 10 30.3361 10 34.7487 10C36.6821 10 37.6488 10 38.5779 10.0869C42.5833 10.4614 46.3826 12.0352 49.4797 14.6026C50.1981 15.1981 50.8816 15.8816 52.2487 17.2487L55 20C59.0789 24.0789 61.1183 26.1183 63.5606 27.4771C64.9022 28.2236 66.3253 28.813 67.8018 29.2339C70.4895 30 73.3737 30 79.1421 30H81.0105C94.1723 30 100.753 30 105.031 33.8473C105.424 34.2012 105.799 34.5757 106.153 34.9692C110 39.2468 110 45.8277 110 58.9895V70C110 88.8562 110 98.2843 104.142 104.142C98.2843 110 88.8562 110 70 110H50C31.1438 110 21.7157 110 15.8579 104.142C10 98.2843 10 88.8562 10 70V34.7487Z",
    fill: "white",
    fillOpacity: 0.06,
    stroke: "white",
    strokeOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3037_9981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 54.2639V30H70V54.2639C70 55.7143 70 56.4395 70.4743 56.7326C70.9485 57.0257 71.5972 56.7014 72.8944 56.0528L79.1056 52.9472L79.1056 52.9472C79.5445 52.7278 79.7639 52.618 80 52.618C80.2361 52.618 80.4555 52.7278 80.8944 52.9472L80.8944 52.9472L87.1056 56.0528C88.4028 56.7014 89.0515 57.0257 89.5257 56.7326C90 56.4395 90 55.7143 90 54.264V54.2639Z",
    fill: "#CCFF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3037_9981",
    x: 66,
    y: 30,
    width: 28,
    height: 34.8398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3037_9981"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3037_9981",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBookmark);
export default __webpack_public_path__ + "static/media/FolderBookmark.c1cb384cc5f1e8d7c09de9db7d2210cb.svg";
export { ForwardRef as ReactComponent };